exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".truncate[data-v-166d43e0]{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.section-header[data-v-166d43e0]{padding:3rem 4rem}.header-process[data-v-166d43e0]{display:flex;align-items:center;gap:3rem}.logo-mytho[data-v-166d43e0]{width:180px}.divider[data-v-166d43e0]{width:.1rem;height:40px;background:#dbdbdb}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-166d43e0","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/cultura/views/ShareCultura.vue
// module id = 1989
// module chunks = 2